import React, { useMemo } from 'react';
import Field from '../../shared/ui/Field';
import {
  getValueFromFormState,
  useFieldController,
  useFormMethods,
} from '../../../../helpers/formManager';
import { fieldPathBuilders } from '../../shared/configs/acceptanceForm';
import {
  useScheduleTypesQuery,
  scheduleTypesSelectors,
} from '../../api/scheduleTypes';
import {
  defaultScheduleTypeId,
  evenOddDayIds,
} from '../../shared/configs/selectionData/scheduleTypes';
import { useEvent } from '../../../../hooks/useEvent';

const {
  scheduleType: createScheduleTypeName,
  scheduleSettings: createScheduleSettingsName,
  isCommonSchedules: createIsCommonSchedulesName,
} = fieldPathBuilders.desk;

const SelectDeskScheduleType = ({ deskIndex, className, disabled }) => {
  const { data: scheduleTypes } = useScheduleTypesQuery({
    options: { select: scheduleTypesSelectors.toOptions },
  });

  const { unregister, getValues } = useFormMethods();

  const names = useMemo(() => createNames(deskIndex), [deskIndex]);

  const {
    field: { value, onChange },
  } = useFieldController({
    name: names.scheduleType,
    defaultValue: defaultScheduleTypeId,
  });

  const handleChange = useEvent((newValue) => {
    onChange(newValue);

    const isEvenOddState =
      evenOddDayIds.has(value) && evenOddDayIds.has(newValue);

    const isCommonSchedules = getValueFromFormState(
      getValues(),
      names.isCommonSchedules
    );

    if (!isEvenOddState && !isCommonSchedules) {
      unregister(names.scheduleSettings);
    }
  });

  return (
    <Field.Memoized
      type={Field.types.dropdownSelect}
      value={value}
      onChange={handleChange}
      options={scheduleTypes}
      multiple={false}
      label="Настройка графика"
      rootCN={className}
      disabled={disabled}
    />
  );
};

export default SelectDeskScheduleType;

function createNames(deskIndex) {
  return {
    scheduleType: createScheduleTypeName(deskIndex),
    scheduleSettings: createScheduleSettingsName(deskIndex),
    isCommonSchedules: createIsCommonSchedulesName(deskIndex),
  };
}
